import React from 'react';
import { Link } from 'react-router-dom';
import Lottie from "lottie-react";

import navinaAnimation01 from '../../assets/imgs/navina/hero.json'; 
import navinaAnimation02 from '../../assets/imgs/navina/QA_Comments_closeups.json'; 
import navinaAnimation03 from '../../assets/imgs/navina/Risk_Adjust_04.json'; 
import navinaAnimation04 from '../../assets/imgs/navina/Risk_Adjust_03.json'; 
import navinaAnimation05 from '../../assets/imgs/navina/QA_Status_change.json'; 
import navinaAnimation06 from '../../assets/imgs/navina/Charts_AN04.json'; 
import navina00 from '../../assets/imgs/navina/navina_snapshot01.png'; 
import navina01 from '../../assets/imgs/navina/panels.png'; 
import otterize from '../../assets/imgs/otterize/otterize-storyboard-img.png'; 


const NavinaWebAnimationsPage = () => {

  return (
        <div className='bg-light'>
          <div className='header-height'></div>
                <div className='row'>
                <div className='col-sm-2 col-xs-none'></div>
                <div className='col-sm col-xs-12'>

                  <div className='row px-3 px-sm-5'>
                  <div className='col-md text-start mb-5 '>
                    <p className='fs-2 fw-normal lh-1 capitalize mb-2'>Navina Web animations</p>
                    <p className='fs-1rem fw-light capitalize'>
                    Enhancing User Experience with Web Animations
                    </p>
                    <p className='mt-4 fw-light'>2024</p>

                  </div>
                  <div className='col-md'>
                    <p className='fw-normal fs-5'>
                      This project involved the design and development of a series of interactive web animations for Navina’s platform and website, helping to showcase its AI-powered solutions for mastering value-based workflows. Utilizing Lottie format and motion design principles, the animations were designed to enhance usability, engagement, and platform navigation, while ensuring seamless performance across all devices.
                    </p>
                  </div>
    
                <div className='mb-sm-5'></div>
                <img className='py-2' src={navina00} width='100%'/>

          </div>
        </div>



      <div className='row m-0 my-5 px-3 px-sm-5'>
        <div className='col-sm-6 col-xs-12'></div>
          <div className='col-sm-6 col-xs-12 my-5 py-5'>
            <h5 className='mb-4'>Bringing Navina’s Brand Identity to Life Through Animation
            </h5>
              <p className='fs-5 fw-normal'>
                Navina’s brand identity embraces minimalism, clean 2D design, and a signature palette of purple and green, creating a modern and intuitive visual language. The web animations were crafted to seamlessly align with this identity, incorporating soft, rounded shapes, smooth transitions, and layered overlays to enhance clarity and user interaction.
              </p>
              <br></br>
              <p className='fs-5 fw-normal'>
              The project included a series of 15 looped animations for the company’s website, designed to visually demonstrate key product features. Additionally, a second series of 10 animations and tutorial guides was created to assist users in navigating the platform within their preferred EHR, ensuring a smooth and intuitive onboarding experience.              </p>
        </div>
      </div>

      <div className='row m-0 p-0'>
        <img className='py-2' src={navina01} width='100%'/>
      </div>

      <div className='row mx-0 my-5 px-3 px-sm-5'>
        <div className='col-sm-6 col-xs-12 mt-5 py-5'>
          <p className='fs-5'>
            The brief contained two parts. The first involved creating the website animations, designed for each of the product tabs: Risk Adjustment, Quality Management, Chart Review, and Analysis Dashboard. The second part focused on developing a version of the animations for users within the platform, helping them navigate the product and find relevant resources during their onboarding experience.
          </p>
          <br></br>
          <p className='fs-5'>
            Bringing the designs to life through motion added personality and clarity to each product tool. The animations used focused framing, smooth scrolling, and mid-cuts to highlight key areas. Several animation principles, including ease-in and ease-out curves, were applied to guide viewer attention naturally, creating a seamless and engaging experience.
            Below a few animations out of 20 made for the official website and the software
          </p>

        </div>
          <div className='col-sm-6 col-xs-12'>
        </div>
      </div>

      <div className='row g-4 p-5 m-0'>
      <div className='col-md col-xs-12'>
        </div>
          <div className='col-md-8 col-xs-12'>
          <Lottie animationData={navinaAnimation01} loop={true} />
          <div className='py-5'></div>
          <Lottie animationData={navinaAnimation02} loop={true} />
          <div className='py-5'></div>
          <Lottie animationData={navinaAnimation03} loop={true} />
          <div className='py-5'></div>
          <p className='fs-5'>
          During the early stages of the project, we explored different animation approaches to ensure they seamlessly matched Navina’s brand identity while enhancing usability. We experimented with various motion techniques, refining transitions and pacing to create engaging yet functional animations. It was also exciting to fine-tune micro-interactions and subtle motion cues, ensuring they not only looked great but also guided users intuitively through the platform.
          </p>
          <div className='py-5'></div>
          <Lottie animationData={navinaAnimation04} loop={true} />
          <div className='py-5'></div>
          <Lottie animationData={navinaAnimation05} loop={true} />
          <div className='py-5'></div>
          <Lottie animationData={navinaAnimation06} loop={true} />
          </div>
        </div>
      </div>





<div className='row py-5 px-3 px-sm-5'>
  <div className='col-sm-2 col-xs-12'></div>
    <div className='col-sm col-xs-12'>

  <div className='py-2'>
    <Link to={"https://navina.ai"}>
        <a className='d-inline-flex align-items-center fs-5 fw-bold text-dark'>
          <h5 className='fs-18 fw-600'>Client: Navina</h5>
            <div className='arrow-out'></div>
              </a>
                </Link>
            </div>


    <div className='py-2'></div>
      <div className='d-block'>
        <h5 className=''>Credits:</h5>
        <ul className='p-0'>
        <li>Art direction $ analysis: Paz Roth</li>
        <li>Storyboard: Navina team, Paz Roth</li>
        <li>UI design: Navina team, Helit Sayfan-Altman </li>
        <li>Animation: Paz Roth</li>
        </ul>
      </div>

    <div className='py-2'></div>

    <div className='row'>
      <div className='col-sm col-xs-12'>
        <h5 className='fs-18 fw-600'>Capabilities</h5>
          <ul className='p-0'>
            <li className='py-1'>Web Animation</li>
            <li className='py-1'>Web Development</li>
            <li className='py-1'>Product Design</li>
            <li className='py-1'>UX/UI</li>
            <li className='py-1'>Design System</li>
          </ul>
      </div>
      <div className='col-sm col-xs-12'>
        <h5 className='fs-18 fw-600'>Softwares</h5>
          <ul className='p-0'>
            <li className='py-1'>Figma</li>
            <li className='py-1'>Illustrator</li>
            <li className='py-1'>After Effect</li>
            <li className='py-1'>Lottie Files</li>
          </ul>
      </div>
      
      <div className='col-sm col-xs-12'>
        <h5 className='fs-18 fw-600'>Cooperation</h5>
          <ul className='p-0'>
            <li className='py-1'>Long-term project</li>
          </ul>
      </div>

      <div className='col-sm col-xs-12'>
        <h5 className='fw-600'>Industry</h5>
            <li className='py-1'>SaaS Healthcare</li>
            <h5 className='fw-600 pt-2'>Duration</h5>
            <li className='py-1'>4 Months</li>
        </div>
      </div>
    </div>
  </div>

  <div className='row mx-0 mt-3 mt-sm-5'>
    <div className='col-sm-12 col-xs-12 text-end p-5'>
        <Link to={"/otterize"}>
          <a className='fs-5 fw-bold text-dark'>
            Next work 
            <div className='arrow-right'></div>
            </a>
              </Link>
          </div>
          <div className='col-sm-2 col-xs-12 p-3 p-sm-5'>

          </div>
            <div className='col-sm col-xs-12 p-0'>
            <Link to={"/otterize"}>
              <div className='image-box-300'>
                <img src={otterize} alt="prodbo next" />
              </div>
            </Link>
          </div>
        </div>
    </div>


  );
};

export default NavinaWebAnimationsPage;
